import React from 'react';

const values = [
    {
        title: 'Precision',
        text: 'Detailing, alignment and approved finishes are set before fabrication, so the facade matches the drawing on site.',
    },
    {
        title: 'Quality',
        text: 'Powder-coated and anodized aluminium, SS 304, toughened glass and ACP are specified for the job and finished cleanly.',
    },
    {
        title: 'Craft',
        text: 'Two glazing lines and site teams carry glass, aluminium, UPVC and steel work from the shop to the building.',
    },
    {
        title: 'Responsibility',
        text: 'Each project is taken through design, fabrication, installation and a turnkey handover.',
    },
];

const partners = [
    { name: 'CSN', place: 'Jamshedpur' },
    { name: 'Navrang Square', place: 'Ghaziabad' },
    { name: 'ATS', place: 'Noida & Greater Noida' },
    { name: 'Amba Deep', place: 'Connaught Place, Delhi' },
    { name: 'T&T', place: 'Ghaziabad' },
    { name: 'Supertech', place: 'Sector 74, Noida' },
    { name: 'Saya', place: 'Greater Noida & Ghaziabad' },
    { name: 'Spectrum Mall', place: 'Sector 75, Noida' },
    { name: 'Central Market', place: 'Sector 120, Noida' },
    { name: 'Gaur Sons', place: 'Ghaziabad' },
    { name: 'Paras Estate', place: 'Meerut' },
];

const AboutPrinciples = () => {
    return (
        <>
            <section className="page-section principles-section">
                <div className="container">
                    <div className="section-intro reveal">
                        <p className="eyebrow">What we stand for</p>
                        <h2 className="section-title">Vision, mission and values</h2>
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6 reveal">
                            <article className="principle-card tilt-3d">
                                <p className="eyebrow">Our vision</p>
                                <p>
                                    To set a clear standard for glass, aluminium and UPVC facade work — precise in detailing and clean in finish — across commercial, residential, hospitality, industrial and IT buildings.
                                </p>
                            </article>
                        </div>
                        <div className="col-lg-6 reveal reveal-delay">
                            <article className="principle-card tilt-3d is-navy">
                                <p className="eyebrow">Our mission</p>
                                <p>
                                    To take every project from design and detailing through fabrication and site installation, and hand it over as a complete turnkey facade solution.
                                </p>
                            </article>
                        </div>
                    </div>
                    <div className="row g-4 principles-values">
                        {values.map((value, index) => (
                            <div className="col-md-6 col-lg-3" key={value.title}>
                                <article className="process-card tilt-3d reveal" style={{ transitionDelay: `${index * 90}ms` }}>
                                    <h3>{value.title}</h3>
                                    <p>{value.text}</p>
                                </article>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="page-section partners-section">
                <div className="container">
                    <div className="section-intro reveal">
                        <p className="eyebrow">Our work partners</p>
                        <h2 className="section-title">Developments we have worked with</h2>
                        <p>
                            facade, glazing, cladding and related work delivered on these projects.
                        </p>
                    </div>
                    <div className="row g-3">
                        {partners.map((partner, index) => (
                            <div className="col-6 col-md-4 col-lg-3" key={partner.name}>
                                <article className="partner-card tilt-3d reveal" style={{ transitionDelay: `${(index % 4) * 70}ms` }}>
                                    <h3>{partner.name}</h3>
                                    <p>{partner.place}</p>
                                </article>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default AboutPrinciples;
